<template>
    <div class="entranceExit">
        <div class="nav clearfix">
            <row>
                <van-col span="2">
                    <Icon name="arrow-left" size="26" @click="getBack" />
                </van-col>
                <van-col span="18" align="center" justify="center" style="font-size:19px;">出入场</van-col>
            </row>
        </div>
        <div style="margin: 100px 100px 50px 100px;" align="center">
            <van-image
                width="150"
                height="150"
                :src="imageurls" rel="external nofollow"
                @click="openCanmer" />
        </div>

        <van-form class="form">
            <van-field
                v-model="barCode"
                required
                icon="question-o"
                label="条码编号:"
                label-class=""
                :border="true"
                maxlength="30"
                placeholder="输入条码编号"
                :rules="[ { required: true, message: '必填' } ]"
                bind:click-icon="onClickIcon" />

            <van-field
                v-model="vehicleCode"
                required
                icon="question-o"
                label="车辆编号:"
                :border="true"
                maxlength="30"
                placeholder="输入车辆编号"
                :rules="[ { required: true, message: '必填' } ]"
                bind:click-icon="onClickIcon" />

            <div style="margin: 50px 100px 0px 100px;">
                <row>
                    <van-col span="8">
                        <van-button round block type="info" @click="entrance">入&nbsp;场</van-button>
                    </van-col>
                    <van-col span="8" offset="8">
                        <van-button round block type="info" @click="exit">出&nbsp;场</van-button>
                    </van-col>
                </row>
            </div>
        </van-form>
        <bottom />
    </div>
</template>

<script>
import { Icon, Notify, Form, Tab, Tabs, DatetimePicker, Popup, Cell, CellGroup, Toast, List, Button, Field, Switch, Radio, Col, Row, RadioGroup, Image } from 'vant'
import bottom from '@/components/bottom'
import { entranceOrExit } from '@/api/maintain'
export default {
    name: 'EntranceExit',
    components: {
        bottom,
        Icon, [Button.name]: Button, [Col.name]: Col, Row, [CellGroup.name]: CellGroup, [Field.name]: Field, Notify, [Form.name]: Form, [Image.name]: Image
    },
    data() {
        return {
            imageurls: require('@/assets/images/scan.jpg'),
            vehicleCode: '',
            barCode: '',
            enumVehicleStatus: 1
        }
    },
    methods: {
        // 返回
        getBack() {
            this.$router.back()
        },
        entrance() {
            if (this.vehicleCode == '' || this.barCode == '') {
                // Toast('车辆编号和条码编号不能为空')
                return
            }
            var data = {}
            data.vehicleCode = this.vehicleCode
            data.barCode = this.barCode
            data.enumVehicleStatus = 1

            entranceOrExit(data).then((res) => {
                if (res.code == 200) {
                    // Toast("入场成功");
                    Notify({ type: 'success', message: '入场成功' })
                } else {
                    Toast(res.message)
                    // Notify({ type: 'warning', message: res.message});
                }
            })
        },
        exit() {
            if (this.vehicleCode == '' || this.barCode == '') {
                // Toast('车辆编号和条码编号不能为空')
                return
            }
            var data = {}
            data.vehicleCode = this.vehicleCode
            data.barCode = this.barCode
            data.enumVehicleStatus = 2

            entranceOrExit(data).then((res) => {
                if (res.code == 200) {
                    // Toast("出场成功");
                    Notify({ type: 'success', message: '出场成功' })
                } else {
                    Toast(res.message)
                    // Notify({ type: 'warning', message: res.message});
                }
            })
        },
        // 打开摄像头
        openCanmer() {
            Toast('打开摄像头')
        }
    }
}
</script>

<style lang='scss' scoped>
.EntranceExit{
  width: 100%;
  .logout{
    margin-top: -20px;
    color: blue;
  }

}
.info-span{
    padding:0px 8px;
    color:#000;
}
.info-span-red{
    padding:0px 8px;
    color:#f00;
}
</style>
<style lang='scss' scoped>
.nav{
  width: 100%;
  padding: 20px 0px;
  background: #3498ff;
  color: #fff;
  .nav-title{
    width: 100%;
    font-size: 30px;
    text-align: center;
    display: block;
  }
}
.noList{
  text-align: center;
  margin-top: 50%;
  font-size: 26px;
  color: #ccc;
}
.van-dialog{
  width: 70%;
  height: 15%;
  .van-dialog__content{
    height: 65%;
    padding-top: 5%;
    text-align: center;
    .van-dialog__message{
      text-align: center;
      font-size: 26px;
    }
  }
  .van-dialog__footer--buttons{
    height: 35%;
    .van-button{
      width: 50%;
      height: 100%;
      .van-button__text{
        font-size: 26px;
      }
    }
  }
}
.form{
    margin: 10px 0;
}
.form .van-cell__title{font-size: 0.4rem !important;}
</style>
